/**
 * @internal
 */
export const removeCommentsFromUnicodeRangesRegex = /\/\*[^*]*\*\//gim;
/**
 * captured from https://www.unicode.org/Public/UCD/latest/ucd/Blocks.txt
 *
 * and combined with LineTo character groups description:
 *
 * Basic Latin - Unicode Block from 0000-007F
 * Latin-1 Supplement - Unicode Block from 0080-00FF
 * Latin Extended-A - Unicode Block from 0100-017F
 * Latin Extended-B - Unicode Block from 0180-024F
 * IPA Extensions - Unicode Block from 0250-02AF
 * Spacing Modifier Letters - Unicode Block from 02B0-02FF
 * Combining Diacritical Marks - Unicode Block from 0300-036Fccc
 * Greek and Coptic - Unicode Block from 0370-03FF
 * Cyrillic - Unicode Block from 0400-04FF
 * Latin Extended Additional - Unicode Block from 1E00-1EFF
 * General Punctuation - Unicode Block from 2000-206F
 * Superscripts and Subscripts - Unicode Block from 2070-209F
 * Currency Symbols - Unicode Block from 20A0-20CF
 * Letterlike Symbols - Unicode Block from 2100-214F
 * Number Forms - Unicode Block from 2150-218F
 * Arrows - Unicode Block from 2190-21FF
 * Mathematical Operators - Unicode Block from 2200-22FF
 * Geometric Shapes - Unicode Block from 25A0-25FF
 * CJK Unified Ideographs - Unicode Block from 4E00-9FFF
 * Private Use Area - Unicode Block from E000-F8FF
 * Alphabetic Presentation Forms - Unicode Block from FB00-FB4F
 * Arabic - Unicode Block from 0600-06FF
 * Arabic Presentation Forms-A - Unicode Block from FB50-FDFF
 * Arabic Presentation Forms-B - Unicode Block from FE70-FEFF
 * Hebrew - Unicode Block from 0590-05FF
 *
 * Unicode character references
 * - https://www.w3.org/TR/xml-entity-names/bycodes.html
 * - https://www.unicode.org/charts
 * - explanation: https://unicode.org/faq/blocks_ranges.html
 * - search a symbol: https://symbl.cc/en/search (use the U+0000 notation)
 *
 * Some notes:
 * - Greek Extended is added because there are 4 characters defined U+1EF2, U+1EF3, U+1EF8 and U+1EF9
 * - Cyrillic Supplement (U+0500-052F) is not added because there are no characters defined in the Polestar Unica 77 TT font
 *
 *
 * Future notes:
 *
 * When RTL is implemented the following ranges are of interest:
 * - 0590-05FF; Hebrew
 *
 * - 0600-06FF; Arabic
 * - 0750-077F; Arabic Supplement
 * - 08A0-08FF; Arabic Extended-A
 * - 0870-089F; Arabic Extended-B
 * - 10EC0-10EFF; Arabic Extended-C
 * - FB50-FDFF; Arabic Presentation Forms-A
 * - 1EE00-1EEFF; Arabic Mathematical Alphabetic Symbols
 *
 * No usage of: 🤷‍♂️
 * - 2C60-2C7F; Latin Extended-C
 * - A720-A7FF; Latin Extended-D
 * - AB30-AB6F; Latin Extended-E
 * - 10780-107BF; Latin Extended-F
 * - 1DF00-1DFFF; Latin Extended-G
 * - 10140-1018F; Ancient Greek Numbers
 * - 1D200-1D24F; Ancient Greek Musical Notation
 * - 2C80-2CFF; Coptic
 * - 2DE0-2DFF; Cyrillic Extended-A
 * - A640-A69F; Cyrillic Extended-B
 * - 1C80-1C8F; Cyrillic Extended-C
 * - 1E030-1E08F; Cyrillic Extended-D
 * - 2E80-2EFF; CJK Radicals Supplement
 * - 3000-303F; CJK Symbols and Punctuation
 * - 31C0-31EF; CJK Strokes
 * - 3200-32FF; Enclosed CJK Letters and Months
 * - 3300-33FF; CJK Compatibility
 * - 3400-4DBF; CJK Unified Ideographs Extension A
 * - F900-FAFF; CJK Compatibility Ideographs
 * - FE30-FE4F; CJK Compatibility Forms
 * - 20000-2A6DF; CJK Unified Ideographs Extension B
 * - 2A700-2B73F; CJK Unified Ideographs Extension C
 * - 2B740-2B81F; CJK Unified Ideographs Extension D
 * - 2B820-2CEAF; CJK Unified Ideographs Extension E
 * - 2CEB0-2EBEF; CJK Unified Ideographs Extension F
 * - 2EBF0-2EE5F; CJK Unified Ideographs Extension I
 * - 2F800-2FA1F; CJK Compatibility Ideographs Supplement
 * - 30000-3134F; CJK Unified Ideographs Extension G
 * - 31350-323AF; CJK Unified Ideographs Extension H

Note: Safari does not render the &nbsp; in Latin Extended if the space (U+0020) is not embedded in the same .woff(2) file. Added it to the latinExtended range fixed the issue.
 */
var FontUnicodeRanges;
(function (FontUnicodeRanges) {
    FontUnicodeRanges["arabic"] = "/* Arabic */U+0600-06FF, /* Arabic Presentation Forms-A */U+FB50-FDFF, /* Arabic Presentation Forms-B */U+FE70-FEFF";
    FontUnicodeRanges["cjk"] = "/* CJK Unified Ideographs */U+4E00-9FFF";
    FontUnicodeRanges["cyrillic"] = "/* Cyrillic */U+0400-04FF";
    FontUnicodeRanges["hebrew"] = "/* Hebrew */U+0590-05FF";
    FontUnicodeRanges["greek"] = "/* Greek and Coptic */U+0370-03FF, /* Greek Extended */U+1F00-1FFF";
    FontUnicodeRanges["latinBasic"] = "/* Basic Latin */U+0000-007F,/* General Punctuation */U+2000-206F, /* Superscripts and Subscripts */U+2070-209F, /* Currency Symbols */U+20A0-20CF, /* Number Forms */U+2150-218F, /* Arrows */U+2190-21FF, /* Mathematical Operators */U+2200-22FF, /* Geometric Shapes */U+25A0-25FF, /* Spacing Modifier Letters */U+02B0-02FF,/* Combining Diacritical Marks */U+0300-036F, /* Alphabetic Presentation Forms */U+FB00-FB4F, /* Letterlike Symbols */U+2100-214F";
    FontUnicodeRanges["latinExtended"] = "/* for the non breaking space */U+0020,/* Latin-1 Supplement */U+0080-009F,U+00A1-00FF,/* Latin Extended-A */U+0100-017F,/* Latin Extended-B */U+0180-024F,/* International Phonetic Alphabet (IPA) Extensions */U+0250-02AF,/* Private Use Area (Polestar logos) */U+E000-F8FF,/* Latin Extended Additional */U+1E00-1EFF";
})(FontUnicodeRanges || (FontUnicodeRanges = {}));
export default FontUnicodeRanges;
